import React from 'react'
import {
  Datagrid,
  List,
  TextField,
  EditButton,
  SelectField,
  DateField,
  TopToolbar,
  DeleteWithConfirmButton,
  SearchInput,
} from 'react-admin'
import { Button } from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import ExportModal from '../../components/ExportModal'
import CustomPagination from '../../MyPagination'
import ContactModal from '../../components/ContactModal'

const TournamentsList = (props) => {
  const [modalType, setModalType] = React.useState(null)
  const handleOpenPlayerModal = () => setModalType('player')
  const handleOpenTournamentModal = () => setModalType('tournament')
  const handleExportModalClose = () => setModalType(null)

  const [contactModalOpened, setContactModalOpened] = React.useState(false)
  const handleOpenContactModal = () => setContactModalOpened(true)
  const handleCloseContactModal = () => setContactModalOpened(false)

  const TournamentsListActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      {/* Add your custom actions */}
      <Button startIcon={<ChatIcon />} color="primary" onClick={handleOpenContactModal}>
        Écrire à tous les organisateurs
      </Button>
      <Button startIcon={<CloudDownloadIcon />} color="primary" onClick={handleOpenPlayerModal}>
        Exporter les joueurs
      </Button>
      <Button startIcon={<CloudDownloadIcon />} color="primary" onClick={handleOpenTournamentModal}>
        Exporter les tournois
      </Button>
    </TopToolbar>
  )

  const postFilters = [<SearchInput source="qName" alwaysOn />]

  return (
    <div>
      <List
        {...props}
        filters={postFilters}
        pagination={<CustomPagination />}
        bulkActionButtons={false}
        actions={<TournamentsListActions />}
        sort={{ field: 'safeName', order: 'ASC' }}
      >
        <Datagrid>
          <TextField source="name" sortBy="safeName" label="Nom" />
          <SelectField
            disabled
            sortable={false}
            source="category"
            label="Catégorie"
            allowEmpty="false"
            choices={[
              {
                id: 'international',
                name: 'International',
              },
              {
                id: 'french',
                name: 'Français',
              },
              {
                id: 'exhibition',
                name: 'Exhibition',
              },
            ]}
          />
          <TextField source="organiserIdCrm" label="IDCRM de l'organisateur" sortable={false} />
          <DateField source="startDate" label="Date de début" />
          <DateField source="endDate" label="Date de fin" />
          <SelectField
            disabled
            label="Homologation du tournoi"
            source="certificationStatus"
            allowEmpty="false"
            choices={[
              {
                id: 'pendingCertification',
                name: 'En attente de validation',
              },
              {
                id: 'certified',
                name: 'Homologué',
              },
              {
                id: 'notCertified',
                name: 'Non homologué',
              },
            ]}
          />
          <SelectField
            label="Inscriptions joueurs"
            source="registrationsStatus"
            allowEmpty="false"
            choices={[
              {
                id: 'opened',
                name: 'Ouvertes',
              },
              {
                id: 'closed',
                name: 'Fermées',
              },
            ]}
          />
          <EditButton label="Éditer le tournoi" basePath="/tournaments" />
          <DeleteWithConfirmButton
            label="Supprimer le tournoi"
            confirmContent="Êtes-vous sûr de vouloir supprimer ce tournoi ? Les données du tournoi et toutes les données liées à ce tournoi seront définitivement perdues."
          />
        </Datagrid>
      </List>
      <ExportModal handleClose={handleExportModalClose} type={modalType} />
      <ContactModal handleClose={handleCloseContactModal} open={contactModalOpened} receiver="ORGANISERS" />
    </div>
  )
}

export default TournamentsList
